import gcd from '../functions/gcd';
import getRandomInt from '../functions/getRandomInt';
import uqnJoin from '../functions/uqnJoin';
//import getRandomIntArray from '../functions/getRandomIntArray';
export default function random1003(type, intType) {
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(0, 8);
        type = (type % 5) + 1;
        //type = 5; //intType = 0;
    }
    let a = getRandomInt(1, 9);
    let b = getRandomInt(1, 9);
    const i = getRandomInt(1, 9);
    if (type == 1) { // dydx = f(x), 
        if (typeof intType === "undefined") {
            intType = getRandomInt(0, 6);
        }
        if (intType > 3) { // no n (b)
            b = 0;
            if (intType == 5) { // no m (a)
                a = 0;
            }
        }
        else if (intType == 1 || intType == 3) { // no m (a)
            a = 0;
        }
    }
    else if (type == 2) { // dydx = f(y)
        if (typeof intType === "undefined") {
            intType = getRandomInt(0, 5);
        }
        a = getRandomInt(0, 7); // a controls type of substitution + value of "m"
        if (a == 5 || a == 7) {
            a = a - 4;
        }
        if (intType == 1 || intType == 2) {
            a = 3;
        }
        else if (intType == 5) {
            b = 0;
        }
    }
    else if (type == 5) { // y=ux^m, x dydx = my - b
        intType = 0;
    }
    else if (type == 3) { // z = ax+by, dydx = (f(ax+by)-a)/b
        if (typeof intType === "undefined") {
            intType = getRandomInt(0, 4);
        }
        if (intType == 0) {
            if (gcd(a, b) != 1) {
                const divisor = gcd(a, b);
                a = a / divisor;
                b = b / divisor;
            }
        }
    }
    else if (type == 4) { // d2ydx2 + a dydx + b, z = dydx
        if (typeof intType === "undefined") {
            intType = getRandomInt(0, 3); // intType controls sign of a/b
        }
    }
    else {
        throw "type out of bounds";
    }
    return uqnJoin([type, intType, a, b, i]);
}
